<template>
  <div>
    <div class="section-header text-center text-md-start mb-2 mb-md-0">
      Date asigurare
    </div>
    <div class="d-flex flex-column align-center justify-center">
      <div v-if="!hasVignette" class="mb-2 d-flex flex-column flex-md-row align-center">
        <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
          {{ simpleStartDateQuestion.text }}
        </v-subheader>
        <date-question
          @updateDate="updatePrimaryDate"
        />
      </div>
      <template v-else>
        <div class="mb-2 d-flex flex-column flex-md-row align-center">
          <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
            {{ greenCardDateQuestion.text }}
          </v-subheader>
          <date-question
            @updateDate="updatePrimaryDate"
          />
        </div>
        <div class="mb-2 d-flex flex-column flex-md-row align-center">
          <v-subheader class="mr-md-3 field-label d-flex justify-center justify-md-end text-center text-md-end">
            {{ vignetteDateQuestion.text }}
          </v-subheader>
          <date-question
            @updateDate="updateVignetteDate"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { confirmationQuestions } from '@/_utils/static-data';
import DateQuestion from '@/components/DateQuestion';
export default {
  name: 'StartDateForm',
  components: { DateQuestion },
  props: {
    hasVignette: Boolean
  },
  data() {
    return {
      validPrimaryDate: false,
      primaryDate: null,
      validVignetteDate: !this.hasVignette,
      vignetteDate: null
    };
  },
  computed: {
    simpleStartDateQuestion() {
      return this.getQuestionById(1);
    },
    greenCardDateQuestion() {
      return this.getQuestionById(11);
    },
    vignetteDateQuestion() {
      return this.getQuestionById(12);
    }
  },
  methods: {
    getQuestionById(id) {
      return confirmationQuestions(id)?.[0];
    },
    updatePrimaryDate({ data, isValid }) {
      this.primaryDate = data?.formattedDate;
      this.validPrimaryDate = isValid;
      this.updateEvent();
    },
    updateVignetteDate({ data, isValid }) {
      this.vignetteDate = data?.formattedDate;
      this.validVignetteDate = isValid;
      this.updateEvent();
    },
    updateEvent() {
      const data = {
        startDate: this.primaryDate,
        isValid: this.validPrimaryDate
      };
      if (this.hasVignette) {
        data.vignetteDate = this.vignetteDate;
        data.isValid = this.validPrimaryDate && this.validVignetteDate;
      }
      setTimeout(() => {
        this.$emit('updateData', data);
      }, 400);
    }
  }
};
</script>

<style scoped>
.section-header {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.field-label {
  width: 150px;
}
@media screen and (max-width: 600px) {
  .field-label {
    width: 100%;
  }
}
</style>
